export default __webpack_public_path__ + "static/media/gallery_04.bcd7dfa2.jpg";